import { render, staticRenderFns } from "./KTabs.vue?vue&type=template&id=4a1e36e4&"
import script from "./KTabs.vue?vue&type=script&lang=js&"
export * from "./KTabs.vue?vue&type=script&lang=js&"
import style0 from "./KTabs.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports